import React from "react";
import TabsSection from "../Tabs/TabsSection";
import NoDataText from "../NoDataText";



const DashboardCategories = (props) => {
  const {TableData} = props
  return (
    <>
      <div className="acc-dashboard mt-4">
      <TabsSection />
      <div class="table-responsive-xl black-header dashboard-Table">
        <table class="recentact-table mt-3 table ver-middle manage-vou-table">
          <thead>
            <tr>
              <th>Business Category</th>
              <th>New Requests</th>
              <th>In-Review</th>
              <th>Published</th>
              <th>Declined</th>
            </tr>
          </thead>
          <tbody>
           {TableData.length != 0 ? (
           <>
            {TableData?.map((item,key)=>{
              return(
                <tr>
                <td>{item.category_name}</td>
                <td>{item.new}</td>
                <td>{item.in_review}</td>
                <td>{item.published}</td>
                <td>{item.declined}</td>
               </tr>
              )
            })}</>
            ): ( <tr class="toggle-row">
            <td colspan="8">
              <p class="noData">{NoDataText.ErrText}</p>{" "}
            </td>
          </tr>)} 
          </tbody>
        </table>
      </div>
      </div>
    </>
  );
};

export default DashboardCategories;
